//Sidebar nav menu js

 
$(window).scroll(function() {

    if($(this).scrollTop()>300) {

        $( "header" ).addClass("fixed_header fadeInDown animated");

    } else {

        $( "header" ).removeClass("fixed_header fadeInDown animated");

    }

});


$(function($) {
 let url = window.location.href;
  $('nav ul li a').each(function() {
   if (this.href === url) {
   $(this).addClass('active');
  }
 });
});


$('.smooth-goto').on('click', function() {  
    $('html, body').animate({scrollTop: $(this.hash).offset().top - 50}, 1000);
    return false;
});


$(".sidebar-dropdown > a").click(function() {
  $(".sidebar-submenu").slideUp(200);
  if (
    $(this)
      .parent()
      .hasClass("active")
  ) {
    $(".sidebar-dropdown").removeClass("active");
    $(this)
      .parent()
      .removeClass("active");
  } else {
    $(".sidebar-dropdown").removeClass("active");
    $(this)
      .next(".sidebar-submenu")
      .slideDown(200);
    $(this)
      .parent()
      .addClass("active");
  }
});

//Owl carousel

$('.owl-carousel').owlCarousel({

    loop:true,

    margin:10,

    dots:false,

    nav:false,

    mouseDrag:false,

    autoplay: true,

    autoPlaySpeed: 6000,

    autoPlayTimeout: 6000,

    autoplayHoverPause: true,

    animateOut: 'slideOutUp',

    responsive:{

        0:{

            items:1

        },

        600:{

            items:1

        },

        1000:{

            items:1

        }

    }

});





$( document ).ready(function() {

  

	// ===== Scroll to Top ==== 

	 $(window).scroll(function() {

	    if ($(this).scrollTop() >= 500) { 

	        $('#return-to-top').fadeIn(200);

	    } else {

	        $('#return-to-top').fadeOut(200);

	    }

	});

	$('#return-to-top').click(function() {

	    $('body,html').animate({

	        scrollTop : 0

	    }, 500);

	});



});



// wow js — offset: 0 triggers animation the instant element enters viewport
new WOW({ offset: 0, mobile: false }).init();



(function($) {
    "use strict";
        //===Testmonial Slider===
    function testmonialcarousel () {
        $('.testmonial-carousel').owlCarousel({
            loop:true,
            margin:30,
            nav:true,
            dots: true,
            autoplayHoverPause:true,
            autoplay: 6000,
            smartSpeed: 700,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:1
                },
                800:{
                    items:1
                },
                1024:{
                    items:1
                },
                1100:{
                    items:1
                },
                1200:{
                    items:1
                }
            }
        })
    }

    //===Gallery Slider===
    function gallerycarousel () {
        $('.gallery-carousel').owlCarousel({
            loop:true,
            margin:0,
            nav:false,
            dots: false,
            autoplayHoverPause:true,
            autoplay: 6000,
            smartSpeed: 700,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:2
                },
                800:{
                    items:4
                },
                1024:{
                    items:5
                },
                1100:{
                    items:6
                },
                1200:{
                    items:6
                }
            }
        })
    }

// ===Project===
    function projectMasonaryLayout() {

        if ($('.post-filter').length) {
            $('.post-filter li').children('span').on("click", function() {
                var Self = $(this);
                var selector = Self.parent().attr('data-filter');
                $('.post-filter li').children('span').parent().removeClass('active');
                Self.parent().addClass('active');


                $('.filter-layout').isotope({
                    filter: selector,
                    animationOptions: {
                        duration: 500,
                        easing: 'linear',
                        queue: false
                    }
                });
                return false;
            });
        }
    }

    
    $(window).on('load', function() {
        projectMasonaryLayout();
        testmonialcarousel();
        gallerycarousel();
    });


})(window.jQuery);